import { render, staticRenderFns } from "./cookies-banner.vue?vue&type=template&id=fcf6d268&scoped=true&"
import script from "./cookies-banner.vue?vue&type=script&lang=ts&"
export * from "./cookies-banner.vue?vue&type=script&lang=ts&"
import style0 from "./cookies-banner.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cookies-banner.vue?vue&type=style&index=1&id=fcf6d268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf6d268",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/profile/profile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcf6d268')) {
      api.createRecord('fcf6d268', component.options)
    } else {
      api.reload('fcf6d268', component.options)
    }
    module.hot.accept("./cookies-banner.vue?vue&type=template&id=fcf6d268&scoped=true&", function () {
      api.rerender('fcf6d268', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/cookies-banner.vue"
export default component.exports